import { render, staticRenderFns } from "./EditarEmendas.vue?vue&type=template&id=0c9d719d&scoped=true"
import script from "./EditarEmendas.vue?vue&type=script&lang=ts"
export * from "./EditarEmendas.vue?vue&type=script&lang=ts"
import style0 from "./EditarEmendas.vue?vue&type=style&index=0&id=0c9d719d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9d719d",
  null
  
)

export default component.exports